
<div id="footerId" class="footer-wrapper" *ngIf="!editMode">
    <div *ngIf="siteElement$ | async as siteElement" [innerHTML]="siteElement.Content | safe:'html'"></div>
    <button class="footer-quickedit d-none d-lg-block mt-3 mr-3"
            mat-mini-fab
            aria-label="Edit footer"
            role="button"
            (click)="editFooter()"
            *ngIf="hasUserPermissionToEdit$ | async">
        <i class="fa fa-pencil" aria-hidden="true"></i>
    </button>
</div>

<div *ngIf="editMode" class="d-none d-md-block footer-editor">
    <form [formGroup]="footerEditorForm">
        <app-html-editor formControlName="FooterContent"></app-html-editor>
        <div class="float-right mt-1">
            <button mat-flat-button color="accent" class="mr-3 primary-contrast-color" (click)="save()" i18n="save text@@save-text">Save</button>
            <button mat-button color="primary" (click)="cancel()" i18n="cancel text@@cancel-text">Cancel</button>
            <button mat-button color="primary" (click)="getTemplate()" i18n="get footer template html@@get-footer-template-html">Get template</button>
        </div>
    </form>

    <div class="d-none">
        <span #danish i18n="@@footer-language-danish" class="da">Danish</span>
        <span #english i18n="@@footer-language-english" class="en">English</span>
        <span #finnish i18n="@@footer-language-finnish" class="fi">Finnish</span>
        <span #norwegian i18n="@@footer-language-norwegian" class="no">Norwegian</span>
        <span #swedish i18n="@@footer-language-swedish" class="sv">Swedish</span>
        <span #and i18n="@@footer-language-and">and</span>
        <span #default i18n="@@footer-language-default">default</span>
    </div>

    <div class="float-left mt-1 pl-1" *ngIf="availableLanguages.length > 0">
        <span i18n="@@footer-available-in">Footer available in</span>
        <span> {{ getAvailableLanguages([danish, english, finnish, norwegian, swedish], and, default) }}</span>
    </div>
</div>
